import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Slider from "react-slick";
import HeadingText from "./atoms/HeadingText";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ParaText from "./atoms/ParaText";
import useTranslate from "../hooks/useTranslate";
import MunishImg from "../assets/images/Munish Nainani.jpeg";
import IgorImg from "../assets/images/Igor Bondarenko.jpeg";
import EmaImg from "../assets/images/ema.jpeg";

const Carosel = () => {
  const teamMembers = useTranslate("aboutpage.carosel");
  const imgMap = {
    "Munish Nainani.jpeg": MunishImg,
    "Igor Bondarenko.jpeg": IgorImg,
    "ema.jpeg ": EmaImg,
  };
  var settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const sliderRef = React.useRef(null);

  const nextSlide = () => {
    sliderRef.current.slickNext();
  };

  const prevSlide = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <section className="bg-white pt-12 pb-24">
      <div className="max-w-6xl mx-auto px-4">
        <HeadingText classes="text-center">Meet Our Team</HeadingText>
        <div className="relative">
          <Slider ref={sliderRef} {...settings}>
            {teamMembers.map((member, index) => (
              <div key={index}>
                <div className=" flex h-[340px] justify-center my-8">
                  <div className="w-60 h-full sm:w-96 flex flex-col items-center bg-primary-100 p-4 transform transition duration-300 ease-in-out hover:scale-105">
                    <img
                      src={imgMap[member.image]}
                      alt={member.name}
                      className="w-40 h-40 object-cover rounded-full mb-4 "
                    />
                    <HeadingText variant="h3" classes="!mb-2">
                      {member.name}
                    </HeadingText>
                    <ParaText classes="text-center">{member.position}</ParaText>
                    <ParaText classes="text-center">
                      {member.description}
                    </ParaText>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 p-3 bg-transparent text-primary hover:text-white hover:bg-primary border border-primary rounded-full transition-colors duration-300 ease-in-out"
          >
            <FaChevronLeft />
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 p-3 bg-transparent text-primary hover:text-white hover:bg-primary border border-primary rounded-full transition-colors duration-300 ease-in-out"
          >
            <FaChevronRight />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Carosel;
